var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("FormPlace", {
                attrs: {
                  data: _vm.place,
                  cities: _vm.cities,
                  loading: _vm.isFormLoading,
                  isNew: !_vm.id,
                  language: _vm.language,
                },
                on: {
                  submit: _vm.placeSubmitHandle,
                  cancel: function ($event) {
                    return _vm.$router.push({ name: "page-places" })
                  },
                  "delete-place": _vm.deletePlace,
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmPlaceRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }